module.exports = __webpack_public_path__ + "img/close-blue.64a12c96.svg";